export default __webpack_public_path__ + "static/media/portfolio-184.a8b494cf.jpg";